// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__2cDh0","tooltip_icon":"tooltip_tooltip_icon__YziIo","dark":"tooltip_dark__k1ZRQ","overlay_body":"tooltip_overlay_body__TbcJX"};